import type { NoteBlockModel } from '@blocksuite/hive-model';
import { BlockComponent } from '@blocksuite/std';
import { css, html } from 'lit';

export class NoteBlockComponent extends BlockComponent<NoteBlockModel> {
  static override styles = css`
    .hive-note-block-container {
      display: flow-root;
    }
    .hive-note-block-container.selected {
      background-color: var(--hive-hover-color);
    }
  `;

  override connectedCallback() {
    super.connectedCallback();
  }

  override renderBlock() {
    return html`
      <div class="hive-note-block-container">
        <div class="hive-block-children-container">
          ${this.renderChildren(this.model)}
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'hive-note': NoteBlockComponent;
  }
}
